export const inboxDefaultPageSize = 50;
export const inboxDefaultStartIndex = 0;
